import { type ComponentPropsWithoutRef, forwardRef } from 'react'
import { useTranslation } from 'next-i18next'
import { twMerge } from 'tailwind-merge'
import { InfoIcon } from 'shared/icons/info-icon'

export const MaintenanceBanner = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'>>(
  ({ className = '', ...props }, ref) => {
    const { t } = useTranslation()

    return (
      <div
        ref={ref}
        role="status"
        data-testid="maintenance-banner"
        className={twMerge(
          'relative flex flex-wrap items-center justify-center gap-1 rounded-none border border-x-0 border-yellow bg-warning-100 p-2 [&_a]:underline',
          className,
        )}
        {...props}
      >
        <div className="flex items-center gap-2">
          <InfoIcon
            className="hidden size-5 shrink-0 fill-yellow lg:block"
            aria-hidden="true"
            focusable="false"
          />
          <span className="flex flex-wrap items-center gap-1 text-sm font-normal text-text-primary">
            {t('core.error.maintenance_error_message')}
          </span>
        </div>
      </div>
    )
  },
)

MaintenanceBanner.displayName = 'MaintenanceBanner'
